export default "__VITE_ASSET__DTcXsYkv__"